import { render, staticRenderFns } from "./IngestDropdown.vue?vue&type=template&id=7c404951&scoped=true"
import script from "./IngestDropdown.vue?vue&type=script&lang=js"
export * from "./IngestDropdown.vue?vue&type=script&lang=js"
import style0 from "./IngestDropdown.vue?vue&type=style&index=0&id=7c404951&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c404951",
  null
  
)

export default component.exports